module.exports = __webpack_public_path__ + "static/img/siwei1.0328e918.png";